import { AppRoutes } from "./router/AppRoutes";
import { AppShell } from "./shell/AppShell";

export function App() {
  return (
    <AppShell>
      <AppRoutes />
    </AppShell>
  );
}
